import { API } from "aws-amplify";

interface AverageRemunerationRequest {
    payload: {
        id: string;
        remuneracionPromedio: any;
    }
}

const API_NAME = 'api-vitalicias';
const API_PATH = '/solicitud/remuneracion-promedio';

export const sendAverageRemuneration = async (data: AverageRemunerationRequest, stateAlertCallback: (status: "success" | "error") => void) => {
    const request = {
        body: data,
        headers: {},
    }

    try {
        const response = await API.patch(API_NAME, API_PATH, request);
        return response;
    } catch (error) { 
        console.error("Error sending average remuneration:", error);
        stateAlertCallback("error");
    }
}